export const Colors = {
    primary: 'rgb(0, 171, 85)' //#008069 //#212d34
}